import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: "" };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || "" };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  handleReset() {
    // Clear potentially corrupt scorecard data so ScoreCard re-renders cleanly
    const onScorecard = window.location.pathname.includes("/scorecard");
    if (onScorecard) {
      localStorage.removeItem("scorecardData");
      localStorage.removeItem("scorecardAccess");
      localStorage.removeItem("scorecardtoken");
    }
    this.setState({ hasError: false, errorMsg: "" });
  }

  render() {
    if (this.state.hasError) {
      const onScorecard = window.location.pathname.includes("/scorecard");
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", padding: "32px", textAlign: "center" }}>
          <div style={{ fontSize: "40px", marginBottom: "16px" }}>⚠️</div>
          <h2 style={{ fontSize: "22px", marginBottom: "12px" }}>Something went wrong</h2>
          <p style={{ color: "#888", marginBottom: "24px", maxWidth: "380px" }}>
            {onScorecard
              ? "There was a problem loading your scorecard. Click below to go back and resubmit."
              : "An unexpected error occurred. You can try again or return to the home page."}
          </p>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center" }}>
            {onScorecard ? (
              <button
                onClick={() => { this.handleReset(); window.location.replace("/dashboard"); }}
                style={{ padding: "10px 22px", background: "#F63D05", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "15px" }}
              >
                Back to Dashboard
              </button>
            ) : (
              <>
                <button
                  onClick={this.handleReset}
                  style={{ padding: "10px 22px", background: "#F63D05", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "15px" }}
                >
                  Try Again
                </button>
                <button
                  onClick={() => window.location.replace("/")}
                  style={{ padding: "10px 22px", background: "transparent", color: "#F63D05", border: "1.5px solid #F63D05", borderRadius: "8px", cursor: "pointer", fontSize: "15px" }}
                >
                  Go to Home
                </button>
              </>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
